import { Validator } from '@vista-digital/validator';
/**
 * Default configuration options for the Event Hero Banner component.
 */
export const defaultEventHeroBannerConfig = {
    actionButton: { show: true },
    poster: { show: true }
};
export const eventHeroBannerConfigValidatorSchema = {
    actionButton: Validator.object({ show: Validator.boolean() }),
    poster: Validator.object({ show: Validator.boolean() })
};
export const eventHeroBannerConfigValidator = Validator.object(eventHeroBannerConfigValidatorSchema);
